import AppContext from "PFApp/app_context";
import { useContext } from "react";

export const useCurrentProfile = () => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  return { data: currentProfile };
};
